import { render, staticRenderFns } from "./VerificationRenouvellement.vue?vue&type=template&id=2f87e36b&"
import script from "./VerificationRenouvellement.vue?vue&type=script&lang=js&"
export * from "./VerificationRenouvellement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports